import {TiposMutationNotificacao} from './tipos-mutation.notificacao';
import {MapActionsNotificacao} from './map-actions.notificacao';

export default {
    namespaced: true,
    state: () => ({
        notificacoes: [],
    }),
    mutations: {
        // @ts-ignore
        [TiposMutationNotificacao.SET_NOTIFICACOES](state: any, notificacoes: []) {
            state.notificacoes = notificacoes;
        }
    },
    actions: {
        // @ts-ignore
        [MapActionsNotificacao.ATUALIZAR_NOTIFICACOES]({commit, state}, notificacoes) {
            commit(TiposMutationNotificacao.SET_NOTIFICACOES, notificacoes);
        },
    },
    getters: {
        notificacoes: (state: any) => state.notificacoes,
    }
};
